<template>
  <div
    v-if="visible"
    class="fixed bottom-4 right-4 z-[9980] flex items-center gap-3 rounded-lg border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 shadow-lg px-3 py-2 max-w-sm"
  >
    <button
      type="button"
      class="flex-1 min-w-0 text-left"
      @click="expand"
    >
      <div class="text-xs text-slate-500 dark:text-slate-400">
        {{ statusLabel }}
      </div>
      <div class="text-sm font-semibold text-slate-800 dark:text-slate-100 truncate">
        {{ remoteNumber || '-' }}
      </div>
      <div
        v-if="callState === 'connected' && transferPhase === 'idle'"
        class="text-xs tabular-nums text-slate-500 dark:text-slate-400"
      >
        {{ formattedDuration }}
      </div>
    </button>

    <template v-if="isInboundRinging">
      <woot-button
        variant="clear"
        color-scheme="secondary"
        size="small"
        @click="hangup"
      >
        Rechazar
      </woot-button>
      <woot-button
        variant="solid"
        color-scheme="primary"
        size="small"
        @click="answer"
      >
        Contestar
      </woot-button>
    </template>
    <template v-else>
      <woot-button
        variant="clear"
        color-scheme="secondary"
        size="small"
        :is-disabled="transferPhase !== 'idle'"
        @click="toggleMute"
      >
        {{ isMuted ? 'Activar micrófono' : 'Silenciar' }}
      </woot-button>

      <woot-button
        variant="clear"
        color-scheme="primary"
        size="small"
        :is-disabled="transferPhase !== 'idle'"
        @click="expand"
      >
        Transferir
      </woot-button>

      <woot-button
        variant="solid"
        color-scheme="alert"
        size="small"
        @click="hangup"
      >
        Colgar
      </woot-button>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'CallMiniBar',
  computed: {
    ...mapGetters({
      callUiMode: 'telephony/callUiMode',
      callState: 'telephony/callState',
      callDirection: 'telephony/callDirection',
      remoteNumber: 'telephony/remoteNumber',
      callDuration: 'telephony/callDuration',
      isMuted: 'telephony/isMuted',
      transferPhase: 'telephony/transferPhase',
      transferTargetName: 'telephony/transferTargetName',
      transferErrorMessage: 'telephony/transferErrorMessage',
    }),
    visible() {
      return (
        this.callUiMode === 'minimized' &&
        (this.callState === 'ringing' || this.callState === 'connected')
      );
    },
    isInboundRinging() {
      return this.callState === 'ringing' && this.callDirection === 'inbound';
    },
    statusLabel() {
      if (this.transferPhase === 'holding') return 'Poniendo en espera…';
      if (this.transferPhase === 'transfer_ringing') {
        return `Transfiriendo a ${this.transferTargetName}`;
      }
      if (this.transferPhase === 'completing') return 'Completando transferencia…';
      if (this.transferPhase === 'rolling_back') return 'Retomando llamada…';
      if (this.transferPhase === 'accepted') {
        return `${this.transferTargetName} contestó`;
      }
      if (this.transferPhase === 'failed') return this.transferErrorMessage;
      if (this.callState === 'connected') return 'En llamada';
      if (this.isInboundRinging) return 'Llamada entrante';
      return 'Llamando…';
    },
    formattedDuration() {
      const total = Number(this.callDuration || 0);
      const m = Math.floor(total / 60)
        .toString()
        .padStart(2, '0');
      const s = Math.floor(total % 60)
        .toString()
        .padStart(2, '0');
      return `${m}:${s}`;
    },
  },
  methods: {
    expand() {
      this.$store.dispatch('telephony/EXPAND');
    },
    toggleMute() {
      if (this.transferPhase !== 'idle') return;
      this.$store.dispatch('telephony/TOGGLE_MUTE');
    },
    answer() {
      this.$store.dispatch('telephony/ANSWER');
    },
    hangup() {
      this.$store.dispatch('telephony/HANGUP');
    },
  },
};
</script>
